<template>
    <div class="absolute left-0 w-full h-full z-40 rounded p-64 text-center">
        <div class="sticky transform -translate-y-2/4 top-1/2">
            <svg-icon v-if="showIcon" class="text-primary mx-auto w-48 h-48" type="lock"/>
            <p
                class="py-24 font-semibold text-body"
                v-html="description"
            ></p>

            <div class="flex justify-center gap-8">
                <simple-button
                    icon="keyboard-arrow-left"
                    look="text"
                    v-if="showCancelButton"
                    @click="cancelLink"
                >
                    {{ cancelButtonText }}
                </simple-button>
                <simple-button
                    display="secondary"
                    look="primary"
                    v-if="showConfirmButton"
                    @click="confirmLink"
                >
                    {{ confirmButtonText }}
                </simple-button>
            </div>
        </div>
    </div>
</template>


<script>
import SvgIcon from './SvgIcon';
import SimpleButton from './SimpleButton';

export default {
    components: {
        'svg-icon': SvgIcon,
        'simple-button': SimpleButton,
    },
    props: {
        description: String,
        cancelButtonLink: String,
        cancelButtonText: String,
        confirmButtonLink: String,
        confirmButtonText: String,
        showConfirmButton: Boolean,
        showCancelButton: Boolean,
        showIcon: { type: Boolean, default: true},
    },
    methods: {
        cancelLink() {
            if (this.cancelButtonLink) {
                this.$router.push({name: this.cancelButtonLink});
            }
        },
        confirmLink() {
            if (this.confirmButtonLink) {
                this.$router.push({name: this.confirmButtonLink});
            }
        },
    },
};
</script>
